window.getStampedPhotos = (productId, widgetKey) =>
  new Promise((resolve) => {
    const url = `https://stamped.io/api/widget/reviews?type=instagram-feed&productId=${productId}&take=100&apiKey=${widgetKey}&storeUrl=birdygrace.myshopify.com`;
    const options = {
      method: "GET",
      crossDomain: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        const arr = [];
        json.data.forEach((image) => {
          arr.push({
            src: image.imageUrl,
            caption: image.mediaText,
            products: image.tags,
            user: image.username,
            timestamp: image.dateCreated,
          });
        });
        resolve(arr);
      })
      .catch((err) => {
        console.error(`error:${err}`);
        resolve({
          error:
            "There was an error fetching the instagram stamped content that powers See It In The Wild",
        });
      });
  });

const buildSeeItInTheWild = () => {
  const seeItInTheWild = document.getElementById("see-it-in-the-wild");
  const carouselContent = seeItInTheWild?.querySelector(
    "#see-it-in-the-wild-content",
  );
  const carouselLeftButton = seeItInTheWild?.querySelector(".carousel-left");
  const carouselRightButton = seeItInTheWild?.querySelector(".carousel-right");
  getStampedPhotos(carouselContent.dataset.gallery, stampedKey).then((data) => {
    if (data.length > 0) {
      document.getElementById("see-it-in-the-wild").style.display = "block";
    }
    /**
     * Center content and hide arrow buttons when carousel has less than 4 images
     */
    if (data.length < 4) {
      carouselContent.classList.add("w-auto");
      carouselContent.classList.add("justify-center");
      carouselContent.classList.remove("w-max");
      carouselLeftButton.classList.add("hidden");
      carouselLeftButton.classList.remove("fine-block");
      carouselRightButton.classList.add("hidden");
      carouselRightButton.classList.remove("fine-block");
    }
    let elements = ``;
    data.forEach((item, index) => {
      if (index < 30) {
        let prev = `null`;
        let next = `null`;

        if (index !== 0) {
          prev = `home-insta-object-${index - 1}`;
        }

        if (index < 30 && index !== data.length - 1) {
          next = `home-insta-object-${index + 1}`;
        }

        elements += `
<div class="insta-image pointer carousel-item flex insta-image-${index}" data-prev="${prev}" data-next="${next}" style="scroll-snap-align:start;" data-timestamp="${
          item.timestamp
        }" data-image="${item.src}" data-caption="${item.caption}"
data-products='${JSON.stringify(
          item.products,
        )}' data-hashtags='${JSON.stringify(item.hashtags)}' data-user="${
          item.user
        }" data-profilepic="${
          item.profile_pic
        }" data-index="${index}" id="home-insta-object-${index}">
<div class="relative">
<picture>
<img height="300" width="300" alt="${
          item.caption
        }" loading="lazy" class="max-w-[25rem] max-h-[25rem] min-w-[13.75rem] min-h-[13.75rem] w-[25vw] h-[25vw] object-cover" src="${
          item.src
        }"  />
</picture>
</div>
</div>
`;
      }
    });
    carouselContent.innerHTML = elements;
    document.querySelectorAll(".insta-image").forEach((insta) => {
      insta.addEventListener("click", showInsta);
    });
  });
};
